<template>
  <div>
    <div class="pt-3">
      <v-row no-gutters style="margin-top:250px;">
        <v-col cols="3" md="3" sm="3" xs="3" align="center"> </v-col>
        <v-col cols="6" md="6" sm="5" xs="5" align="center">
          <v-progress-circular
            :size="70"
            :width="7"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </v-col>
      </v-row>
      <v-row>
        <v-col align="center" class="ml-3">
          <span class="kanitFamily">
            LOADING.....
          </span>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
// import { mapState } from 'vuex'

export default {
  data() {
    return { }
  },
  created() { },
  // beforeRouteEnter(to, from, next) {},
  computed: { },
  methods: { }
}
</script>

<style scoped>

</style>
